import { CEPlanAttributesBase } from './ce-plan-attributes-base'


export class CEPlanAttributes extends CEPlanAttributesBase {

}